import QuestionPage from '@app-studio-web/ui/pages/QuestionPage'
import { useTranslation } from 'react-i18next'
import { useSubmit } from 'react-router-dom'
import useUpdateMode from '../../hooks/useUpdateMode'
import { saveAnswer } from '../../utils/onboardingStorage'

const QUESTION_KEY = 'dream_blocks'

export default function DreamBlocksPage() {
  const submit = useSubmit()
  const { t } = useTranslation()

  const { isUpdate, postToReactNative } = useUpdateMode()

  const onSubmit = (event: React.FormEvent<HTMLFormElement>) => {
    const formData = new FormData(event.currentTarget)
    const formAnswer = formData.get('answer') as string

    const answer = {
      question_key: QUESTION_KEY,
      question: 'What stops you from remembering or recording your dreams?',
      answer_key: formAnswer.toLowerCase(),
      answer: formAnswer,
    }

    if (isUpdate) {
      postToReactNative(answer)
    } else {
      saveAnswer(QUESTION_KEY, answer)
      submit(formData, { method: 'post' })
    }
  }

  return (
    <QuestionPage
      heading={t('pages.onboarding.dreamBlocks.heading')}
      buttons={[
        {
          text: `⏰ ${t('pages.onboarding.dreamBlocks.options.noTime')}`,
          value: 'No time in the morning',
          subtext: t('pages.onboarding.dreamBlocks.subtexts.noTime'),
        },
        {
          text: `💨 ${t('pages.onboarding.dreamBlocks.options.forgotQuickly')}`,
          value: 'Dreams fade too quickly',
          subtext: t('pages.onboarding.dreamBlocks.subtexts.forgotQuickly'),
        },
        {
          text: `🤷 ${t('pages.onboarding.dreamBlocks.options.dontKnowHow')}`,
          value: 'I dont know what to write',
          subtext: t('pages.onboarding.dreamBlocks.subtexts.dontKnowHow'),
        },
        {
          text: `😴 ${t('pages.onboarding.dreamBlocks.options.tooTired')}`,
          value: 'Too tired when I wake up',
          subtext: t('pages.onboarding.dreamBlocks.subtexts.tooTired'),
        },
        {
          text: `🎯 ${t('pages.onboarding.dreamBlocks.options.noMotivation')}`,
          value: 'Lack of consistency',
          subtext: t('pages.onboarding.dreamBlocks.subtexts.noMotivation'),
        },
      ]}
      onSubmit={onSubmit}
      headingSize="text-3xl"
      buttonTextSize="text-base"
      buttonBgColor="bg-white"
    />
  )
}
